import {
  AccordionButtonProps,
  Box,
  Accordion,
  AccordionItem,
  AccordionButton,
  Text,
  AccordionPanel,
  RadioGroup,
  Flex,
  Radio,
} from '@everlywell/ui-kit';
import Price from 'components/Price';
import React from 'react';

export type MembershipOptionsProps = AccordionButtonProps & {
  isSelected?: boolean;
  selectedValue: 'monthly' | 'annually';
  onRadioGroupChange: (value: string) => void;
};

/**
 * [Add the description for what this component does here].
 */
const MembershipOptions = (props: MembershipOptionsProps) => {
  const { isSelected, selectedValue, onRadioGroupChange, ...rest } = props;
  return (
    <Accordion index={isSelected ? 0 : -1}>
      <AccordionItem
        width="100%"
        background="tints.lightCream"
        borderRadius={'12px'}
        border="none"
        sx={{
          ...(isSelected
            ? {
                boxShadow: (theme) =>
                  `0px 0px 0px 2px inset ${theme.colors.viridian.base}`,
              }
            : {}),
        }}
      >
        <AccordionButton
          alignItems={'center'}
          aria-pressed={isSelected}
          data-testid="membership-accordion-button"
          justifyContent="space-between"
          padding={4}
          {...rest}
        >
          <Box textAlign={'start'}>
            <Text>Enjoy the best of Everlywell for less</Text>
            <Text size="sm" color="tints.darkGrey">
              Join Everlywell+ and get insights on up to 289 unique biomarkers,
              plus year-round virtual care.
            </Text>
          </Box>
        </AccordionButton>
        <AccordionPanel paddingBottom={0}>
          <Box as="hr" marginX={4} color="tints.darkCream" />
          <Box padding={4}>
            <RadioGroup
              display="flex"
              gap={4}
              flexDirection="column"
              value={selectedValue}
              onChange={onRadioGroupChange}
            >
              <Radio value="annually">
                <Flex justifyContent="space-between" width="100%">
                  <Box textAlign={'start'}>
                    <Text>Everlywell+ annual membership</Text>
                    <Text size="sm" color="tints.darkGrey">
                      Includes one credit per month; Limited-time bonus: 2
                      additional credits on sign up ($78 value).
                    </Text>
                  </Box>
                  <Box textAlign={'end'}>
                    <Price price={449} fontSize="2xl" fontWeight={'medium'} />
                    <Text size="sm" color="tints.darkGrey">
                      / year
                    </Text>
                  </Box>
                </Flex>
              </Radio>
              <Radio value="monthly">
                <Flex justifyContent="space-between" width="100%">
                  <Box textAlign={'start'}>
                    <Text>Everlywell+ monthly membership</Text>
                    <Text size="sm" color="tints.darkGrey">
                      Includes one credit per month; Cancel any time.
                    </Text>
                  </Box>
                  <Box textAlign={'end'}>
                    <Price price={39} fontSize="2xl" fontWeight={'medium'} />
                    <Text size="sm" color="tints.darkGrey">
                      / month
                    </Text>
                  </Box>
                </Flex>
              </Radio>
            </RadioGroup>
          </Box>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};

export default MembershipOptions;
